var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateGroupDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.285 4.542a.208.208 0 01.16-.342h5.11c.177 0 .273.206.16.342l-2.33 2.797a.5.5 0 01-.77 0l-2.33-2.797z",
    fill: "#939CAD"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMjg0NzUgNC41NDE5QzMuMTcxNjggNC40MDYyMSAzLjI2ODE3IDQuMjAwMiAzLjQ0NDggNC4yMDAySDguNTU1MkM4LjczMTgzIDQuMjAwMiA4LjgyODMyIDQuNDA2MjEgOC43MTUyNSA0LjU0MTlMNi4zODQxMSA3LjMzOTI2QzYuMTg0MjEgNy41NzkxNCA1LjgxNTc5IDcuNTc5MTQgNS42MTU4OSA3LjMzOTI2TDMuMjg0NzUgNC41NDE5WiIgZmlsbD0iIzkzOUNBRCIvPgo8L3N2Zz4K";
export { SvgTemplateGroupDown as ReactComponent };